/**
 * Starts the MSW browser worker for live request mocking in dev.
 *
 * Runs automatically in dev and is tree-shaken out of production builds, since
 * the worker import is guarded by `import.meta.env.DEV`. To turn mocking off,
 * empty the handlers in `handlers.ts` (unhandled requests pass through anyway).
 *
 * Scope note: the app is served under `/web-2/new-app/`, but its API requests
 * use root-relative paths (`/v1/...`, `/v2/...`). A service worker only
 * intercepts requests inside its scope, so we register the worker at scope `/`.
 * That requires the worker script to be served with `Service-Worker-Allowed: /`,
 * which the `mswServiceWorkerHeader` Vite plugin adds in dev.
 */
export const startMockServiceWorker = async (): Promise<void> => {
  if (!import.meta.env.DEV) {
    return;
  }

  const { worker } = await import("./browser");

  await worker.start({
    serviceWorker: {
      // Vite serves `public/` under the configured base in dev.
      url: `${import.meta.env.BASE_URL}mockServiceWorker.js`,
      options: { scope: "/" },
    },
    // Let unmocked requests hit the real network so you can mock incrementally.
    onUnhandledRequest: "bypass",
  });

  // eslint-disable-next-line no-console
  console.info("[MSW] Live request mocking enabled.");
};
